import { get, post, put, remove } from "../../api_helper";
import * as url from "../../url_helper";

const baseURL = process.env.REACT_APP_API_DOTNET_URL;

export const createCBARLog = (payload) => post(baseURL + url.CBAR_LOG, payload);
export const getCBARLogDetails = (id) => get(`${baseURL + url.CBAR_LOG}/${id}`);
export const updateCBARLog = (id, payload) => put(`${baseURL + url.CBAR_LOG}/${id}`, payload);
export const deleteCBARLog = (id) => remove(`${baseURL + url.CBAR_LOG}/${id}`);
